// extracted by mini-css-extract-plugin
module.exports = {"Language":"Language_Language__14a4e","link":"Language_link__1XI2r","active":"Language_active__3uXUG"};